import { render, staticRenderFns } from "./kpi-card.vue?vue&type=template&id=5055a8ce&scoped=true&"
import script from "./kpi-card.vue?vue&type=script&lang=js&"
export * from "./kpi-card.vue?vue&type=script&lang=js&"
import style0 from "./kpi-card.vue?vue&type=style&index=0&id=5055a8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5055a8ce",
  null
  
)

export default component.exports